export function AdminCard({
  children,
  title,
  actions,
  className = '',
  noPadding = false
}) {
  return (
    <div className={`admin-card ${className}`}>
      {title && (
        <div className="admin-card-header">
          <h3 className="admin-card-title">{title}</h3>
          {actions && <div className="admin-card-actions">{actions}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'admin-card-body'}>
        {children}
      </div>
    </div>
  );
}
